export const Config = {
	API_ENDPOINT: process.env.VUE_APP_API_ENDPOINT,
}
